import React, { useState, useContext, createContext } from 'react';
import './App.css';

// Language Context
const LanguageContext = createContext();

// Language Provider
const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  
  const translations = {
    en: {
      // Navigation
      services: 'Services',
      about: 'About Us',
      careers: 'Careers',
      contacts: 'Contacts',
      contact: 'Contact',
      
      // Hero Section
      heroTitle: 'V1 Ting',
      heroSubtitle: 'IT Company',
      heroDescription: 'We build the future through technology',
      orderService: 'Order a Website / Service',
      
      // Services
      servicesTitle: 'Our Services',
      servicesSubtitle: 'Technology solutions for your business',
      servicesList: [
        'Landing page',
        'Business card website',
        'Corporate website',
        'Online store (e-commerce)',
        'Website redesign',
        'Content update',
        'Page indexing',
        'Web & mobile app development',
        'Business process automation',
        'AI integration',
        'Blockchain & smart contracts',
        'Custom software development'
      ],
      
      // About
      aboutTitle: 'About Us',
      aboutText: 'V1 Ting is a Kyiv-based IT company and web studio collaborating with clients and specialists across Europe and the US. We specialize in business process automation, web and mobile app development, artificial intelligence integration, blockchain solutions (smart contracts), and custom software development. For over 4 years, we have built a reputation as a reliable technology partner delivering high quality, innovation, and a personalized approach to every project.',
      
      // Careers
      careersTitle: 'Careers',
      careersSubtitle: 'Join our team of innovators',
      positions: [
        'Frontend Developer (React / Next.js)',
        'Backend Developer (Node.js / Python)',
        'UI/UX Designer',
        'AI Integration Engineer',
        'Sales / Client Manager'
      ],
      
      // Contact Form
      contactTitle: 'Get in Touch',
      name: 'Name',
      email: 'Email',
      phone: 'Phone / Telegram',
      message: 'Message',
      send: 'Send Message',
      
      // Career Form
      applyTitle: 'Apply Now',
      position: 'Position',
      selectPosition: 'Select Position',
      apply: 'Apply',
      
      // Footer
      telegram: 'Telegram',
      emailLabel: 'Email',
      footerText: '© 2024 V1 Ting. All rights reserved.'
    },
    uk: {
      // Navigation
      services: 'Послуги',
      about: 'Про нас',
      careers: 'Кар\'єра',
      contacts: 'Контакти',
      contact: 'Контакт',
      
      // Hero Section
      heroTitle: 'V1 Ting',
      heroSubtitle: 'IT компанія',
      heroDescription: 'Ми будуємо майбутнє через технології',
      orderService: 'Замовити веб-сайт / послугу',
      
      // Services
      servicesTitle: 'Наші послуги',
      servicesSubtitle: 'Технологічні рішення для вашого бізнесу',
      servicesList: [
        'Лендінг-сторінка',
        'Сайт-візитка',
        'Корпоративний сайт',
        'Інтернет-магазин (e-commerce)',
        'Редизайн сайту',
        'Оновлення контенту',
        'Індексація сторінок',
        'Розробка веб та мобільних додатків',
        'Автоматизація бізнес-процесів',
        'Інтеграція ШІ',
        'Блокчейн та смарт-контракти',
        'Розробка спеціального ПЗ'
      ],
      
      // About
      aboutTitle: 'Про нас',
      aboutText: 'V1 Ting - це київська IT компанія та веб-студія, яка співпрацює з клієнтами та фахівцями по всій Європі та США. Ми спеціалізуємося на автоматизації бізнес-процесів, розробці веб- та мобільних додатків, інтеграції штучного інтелекту, блокчейн-рішеннях (смарт-контракти) та розробці спеціального програмного забезпечення. Протягом більше 4 років ми створили репутацію надійного технологічного партнера, що забезпечує високу якість, інновації та персоналізований підхід до кожного проекту.',
      
      // Careers
      careersTitle: 'Кар\'єра',
      careersSubtitle: 'Приєднуйтесь до нашої команди інноваторів',
      positions: [
        'Frontend розробник (React / Next.js)',
        'Backend розробник (Node.js / Python)',
        'UI/UX дизайнер',
        'Інженер інтеграції ШІ',
        'Менеджер з продажів / клієнтів'
      ],
      
      // Contact Form
      contactTitle: 'Зв\'яжіться з нами',
      name: 'Ім\'я',
      email: 'Email',
      phone: 'Телефон / Telegram',
      message: 'Повідомлення',
      send: 'Надіслати',
      
      // Career Form
      applyTitle: 'Подати заявку',
      position: 'Посада',
      selectPosition: 'Оберіть посаду',
      apply: 'Подати заявку',
      
      // Footer
      telegram: 'Telegram',
      emailLabel: 'Email',
      footerText: '© 2024 V1 Ting. Всі права захищені.'
    },
    ru: {
      // Navigation
      services: 'Услуги',
      about: 'О нас',
      careers: 'Карьера',
      contacts: 'Контакты',
      contact: 'Контакт',
      
      // Hero Section
      heroTitle: 'V1 Ting',
      heroSubtitle: 'IT компания',
      heroDescription: 'Мы строим будущее через технологии',
      orderService: 'Заказать веб-сайт / услугу',
      
      // Services
      servicesTitle: 'Наши услуги',
      servicesSubtitle: 'Технологические решения для вашего бизнеса',
      servicesList: [
        'Лендинг-страница',
        'Сайт-визитка',
        'Корпоративный сайт',
        'Интернет-магазин (e-commerce)',
        'Редизайн сайта',
        'Обновление контента',
        'Индексация страниц',
        'Разработка веб и мобильных приложений',
        'Автоматизация бизнес-процессов',
        'Интеграция ИИ',
        'Блокчейн и смарт-контракты',
        'Разработка специального ПО'
      ],
      
      // About
      aboutTitle: 'О нас',
      aboutText: 'V1 Ting - это киевская IT компания и веб-студия, сотрудничающая с клиентами и специалистами по всей Европе и США. Мы специализируемся на автоматизации бизнес-процессов, разработке веб- и мобильных приложений, интеграции искусственного интеллекта, блокчейн-решениях (смарт-контракты) и разработке специального программного обеспечения. За более чем 4 года мы создали репутацию надежного технологического партнера, обеспечивающего высокое качество, инновации и персонализированный подход к каждому проекту.',
      
      // Careers
      careersTitle: 'Карьера',
      careersSubtitle: 'Присоединяйтесь к нашей команде инноваторов',
      positions: [
        'Frontend разработчик (React / Next.js)',
        'Backend разработчик (Node.js / Python)',
        'UI/UX дизайнер',
        'Инженер интеграции ИИ',
        'Менеджер по продажам / клиентам'
      ],
      
      // Contact Form
      contactTitle: 'Свяжитесь с нами',
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон / Telegram',
      message: 'Сообщение',
      send: 'Отправить',
      
      // Career Form
      applyTitle: 'Подать заявку',
      position: 'Должность',
      selectPosition: 'Выберите должность',
      apply: 'Подать заявку',
      
      // Footer
      telegram: 'Telegram',
      emailLabel: 'Email',
      footerText: '© 2024 V1 Ting. Все права защищены.'
    }
  };
  
  const t = (key) => translations[language][key] || key;
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Header Component
const Header = () => {
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };
  
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm border-b border-gray-800">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="text-xl font-mono font-bold text-white glitch-text">
              V1 Ting
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('services')} className="nav-link">
                {t('services')}
              </button>
              <button onClick={() => scrollToSection('about')} className="nav-link">
                {t('about')}
              </button>
              <button onClick={() => scrollToSection('careers')} className="nav-link">
                {t('careers')}
              </button>
              <button onClick={() => scrollToSection('contacts')} className="nav-link">
                {t('contacts')}
              </button>
            </nav>
            
            {/* Language Switcher & Contact Button */}
            <div className="flex items-center space-x-4">
              <div className="hidden md:flex items-center space-x-2">
                <button
                  onClick={() => setLanguage('en')}
                  className={`px-2 py-1 text-sm font-mono ${language === 'en' ? 'text-white bg-gray-800' : 'text-gray-400 hover:text-white'}`}
                >
                  EN
                </button>
                <button
                  onClick={() => setLanguage('uk')}
                  className={`px-2 py-1 text-sm font-mono ${language === 'uk' ? 'text-white bg-gray-800' : 'text-gray-400 hover:text-white'}`}
                >
                  UK
                </button>
                <button
                  onClick={() => setLanguage('ru')}
                  className={`px-2 py-1 text-sm font-mono ${language === 'ru' ? 'text-white bg-gray-800' : 'text-gray-400 hover:text-white'}`}
                >
                  RU
                </button>
              </div>
              
              <button
                onClick={() => setIsContactModalOpen(true)}
                className="bg-white text-black px-4 py-2 font-mono hover:bg-gray-200 transition-colors"
              >
                {t('contact')}
              </button>
              
              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden text-white"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
          
          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden mt-4 py-4 border-t border-gray-800">
              <div className="flex flex-col space-y-4">
                <button onClick={() => scrollToSection('services')} className="nav-link text-left">
                  {t('services')}
                </button>
                <button onClick={() => scrollToSection('about')} className="nav-link text-left">
                  {t('about')}
                </button>
                <button onClick={() => scrollToSection('careers')} className="nav-link text-left">
                  {t('careers')}
                </button>
                <button onClick={() => scrollToSection('contacts')} className="nav-link text-left">
                  {t('contacts')}
                </button>
                
                <div className="flex items-center space-x-2 pt-2">
                  <button
                    onClick={() => setLanguage('en')}
                    className={`px-2 py-1 text-sm font-mono ${language === 'en' ? 'text-white bg-gray-800' : 'text-gray-400'}`}
                  >
                    EN
                  </button>
                  <button
                    onClick={() => setLanguage('uk')}
                    className={`px-2 py-1 text-sm font-mono ${language === 'uk' ? 'text-white bg-gray-800' : 'text-gray-400'}`}
                  >
                    UK
                  </button>
                  <button
                    onClick={() => setLanguage('ru')}
                    className={`px-2 py-1 text-sm font-mono ${language === 'ru' ? 'text-white bg-gray-800' : 'text-gray-400'}`}
                  >
                    RU
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>
      
      {/* Contact Modal */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </>
  );
};

// Hero Section
const Hero = () => {
  const { t } = useContext(LanguageContext);
  
  const scrollToOrder = () => {
    const element = document.getElementById('order-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1608507777764-87bf8d185474")'
        }}
      />
      
      {/* Noise Overlay */}
      <div className="absolute inset-0 noise-overlay opacity-20" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-6xl md:text-8xl font-mono font-bold text-white mb-4 glitch-text">
          {t('heroTitle')}
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 font-mono mb-6">
          {t('heroSubtitle')}
        </p>
        <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
          {t('heroDescription')}
        </p>
        
        <button
          onClick={scrollToOrder}
          className="bg-white text-black px-8 py-4 font-mono text-lg hover:bg-gray-200 transition-colors transform hover:scale-105"
        >
          {t('orderService')}
        </button>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

// Services Section
const Services = () => {
  const { t } = useContext(LanguageContext);
  
  return (
    <section id="services" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-mono font-bold text-white mb-4">
            {t('servicesTitle')}
          </h2>
          <p className="text-xl text-gray-400">
            {t('servicesSubtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t('servicesList').map((service, index) => (
            <div key={index} className="bg-black/50 border border-gray-800 p-6 hover:border-gray-600 transition-colors group">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-white group-hover:bg-gray-300 transition-colors" />
                <h3 className="font-mono text-white group-hover:text-gray-300 transition-colors">
                  {service}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section
const About = () => {
  const { t } = useContext(LanguageContext);
  
  return (
    <section id="about" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-mono font-bold text-white mb-8">
              {t('aboutTitle')}
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed">
              {t('aboutText')}
            </p>
          </div>
          
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1562244958-41fabe8adc23"
              alt="V1 Ting Technology"
              className="w-full h-96 object-cover filter grayscale"
            />
            <div className="absolute inset-0 bg-black/30" />
          </div>
        </div>
      </div>
    </section>
  );
};

// Careers Section
const Careers = () => {
  const { t } = useContext(LanguageContext);
  const [isCareerModalOpen, setIsCareerModalOpen] = useState(false);
  
  return (
    <>
      <section id="careers" className="py-20 bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-mono font-bold text-white mb-4">
              {t('careersTitle')}
            </h2>
            <p className="text-xl text-gray-400">
              {t('careersSubtitle')}
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            {t('positions').map((position, index) => (
              <div key={index} className="bg-black/50 border border-gray-800 p-6 mb-4 hover:border-gray-600 transition-colors group">
                <div className="flex items-center justify-between">
                  <h3 className="font-mono text-white text-lg group-hover:text-gray-300 transition-colors">
                    {position}
                  </h3>
                  <button
                    onClick={() => setIsCareerModalOpen(true)}
                    className="bg-white text-black px-4 py-2 font-mono text-sm hover:bg-gray-200 transition-colors"
                  >
                    {t('apply')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <CareerModal 
        isOpen={isCareerModalOpen} 
        onClose={() => setIsCareerModalOpen(false)} 
      />
    </>
  );
};

// Contacts Section
const Contacts = () => {
  const { t } = useContext(LanguageContext);
  
  return (
    <section id="contacts" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-mono font-bold text-white mb-4">
            {t('contacts')}
          </h2>
        </div>
        
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-gray-900/50 border border-gray-800 p-8">
            <div className="space-y-6">
              <div>
                <h3 className="font-mono text-white text-lg mb-2">{t('telegram')}</h3>
                <a 
                  href="https://t.me/fjhjhjg" 
                  className="text-gray-300 hover:text-white transition-colors font-mono"
                >
                  @fjhjhjg
                </a>
              </div>
              
              <div>
                <h3 className="font-mono text-white text-lg mb-2">{t('emailLabel')}</h3>
                <a 
                  href="mailto:viting@gmail.com" 
                  className="text-gray-300 hover:text-white transition-colors font-mono"
                >
                  viting@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Order Form Section
const OrderForm = () => {
  const { t } = useContext(LanguageContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    
    const telegramMessage = `🚀 <b>Новый заказ с сайта V1 Ting</b>

👤 <b>Имя:</b> ${formData.name}
📧 <b>Email:</b> ${formData.email}
📞 <b>Телефон:</b> ${formData.phone || 'Не указан'}
💬 <b>Сообщение:</b> ${formData.message}

🌐 <b>Тип:</b> Заказ услуги
📅 <b>Дата:</b> ${new Date().toLocaleString('ru-RU')}`;

    const result = await sendToTelegram(telegramMessage);
    
    if (result.success) {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } else {
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
    
    // Hide status message after 5 seconds
    setTimeout(() => setSubmitStatus(''), 5000);
  };
  
  return (
    <section id="order-form" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-mono font-bold text-white mb-4">
              {t('orderService')}
            </h2>
          </div>
          
          <form onSubmit={handleSubmit} className="bg-black/50 border border-gray-800 p-8">
            {/* Status Messages */}
            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-900/50 border border-green-700 text-green-300 font-mono">
                ✅ Отправлено успешно! Мы свяжемся с вами в ближайшее время.
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-900/50 border border-red-700 text-red-300 font-mono">
                ❌ Ошибка при отправке. Попробуйте позже или напишите нам в Telegram.
              </div>
            )}
            
            <div className="space-y-6">
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('name')} *
                </label>
                <input
                  type="text"
                  required
                  disabled={isSubmitting}
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full bg-gray-900 border border-gray-700 text-white px-4 py-3 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('email')} *
                </label>
                <input
                  type="email"
                  required
                  disabled={isSubmitting}
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full bg-gray-900 border border-gray-700 text-white px-4 py-3 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('phone')}
                </label>
                <input
                  type="text"
                  disabled={isSubmitting}
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full bg-gray-900 border border-gray-700 text-white px-4 py-3 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('message')} *
                </label>
                <textarea
                  required
                  rows="4"
                  disabled={isSubmitting}
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  className="w-full bg-gray-900 border border-gray-700 text-white px-4 py-3 font-mono focus:border-white focus:outline-none resize-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-white text-black py-4 font-mono text-lg hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Отправка...' : t('send')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

// Contact Modal Component
const ContactModal = ({ isOpen, onClose }) => {
  const { t } = useContext(LanguageContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    
    const telegramMessage = `📨 <b>Новое сообщение с сайта V1 Ting</b>

👤 <b>Имя:</b> ${formData.name}
📧 <b>Email:</b> ${formData.email}
📞 <b>Телефон:</b> ${formData.phone || 'Не указан'}
💬 <b>Сообщение:</b> ${formData.message}

🌐 <b>Тип:</b> Контакт
📅 <b>Дата:</b> ${new Date().toLocaleString('ru-RU')}`;

    const result = await sendToTelegram(telegramMessage);
    
    if (result.success) {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => {
        onClose();
        setSubmitStatus('');
      }, 2000);
    } else {
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-gray-900 border border-gray-700 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-mono text-white">{t('contactTitle')}</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Status Messages */}
          {submitStatus === 'success' && (
            <div className="mb-4 p-3 bg-green-900/50 border border-green-700 text-green-300 font-mono text-sm">
              ✅ Отправлено успешно!
            </div>
          )}
          
          {submitStatus === 'error' && (
            <div className="mb-4 p-3 bg-red-900/50 border border-red-700 text-red-300 font-mono text-sm">
              ❌ Ошибка при отправке. Попробуйте позже.
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('name')} *
                </label>
                <input
                  type="text"
                  required
                  disabled={isSubmitting}
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('email')} *
                </label>
                <input
                  type="email"
                  required
                  disabled={isSubmitting}
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('phone')}
                </label>
                <input
                  type="text"
                  disabled={isSubmitting}
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('message')} *
                </label>
                <textarea
                  required
                  rows="3"
                  disabled={isSubmitting}
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none resize-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-white text-black py-3 font-mono hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Отправка...' : t('send')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Career Modal Component
const CareerModal = ({ isOpen, onClose }) => {
  const { t } = useContext(LanguageContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    position: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    
    const telegramMessage = `🧑‍💼 <b>Новая заявка на вакансию</b>

👤 <b>Имя:</b> ${formData.name}
📧 <b>Email:</b> ${formData.email}
📱 <b>Телефон:</b> ${formData.phone || 'Не указан'}
💼 <b>Позиция:</b> ${formData.position}

🌐 <b>Тип:</b> Заявка на вакансию
📅 <b>Дата:</b> ${new Date().toLocaleString('ru-RU')}`;

    const result = await sendToTelegram(telegramMessage);
    
    if (result.success) {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', position: '' });
      setTimeout(() => {
        onClose();
        setSubmitStatus('');
      }, 2000);
    } else {
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-gray-900 border border-gray-700 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-mono text-white">{t('applyTitle')}</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Status Messages */}
          {submitStatus === 'success' && (
            <div className="mb-4 p-3 bg-green-900/50 border border-green-700 text-green-300 font-mono text-sm">
              ✅ Заявка отправлена успешно!
            </div>
          )}
          
          {submitStatus === 'error' && (
            <div className="mb-4 p-3 bg-red-900/50 border border-red-700 text-red-300 font-mono text-sm">
              ❌ Ошибка при отправке. Попробуйте позже.
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('name')} *
                </label>
                <input
                  type="text"
                  required
                  disabled={isSubmitting}
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('email')} *
                </label>
                <input
                  type="email"
                  required
                  disabled={isSubmitting}
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('phone')}
                </label>
                <input
                  type="text"
                  disabled={isSubmitting}
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              
              <div>
                <label className="block text-white font-mono mb-2">
                  {t('position')} *
                </label>
                <select
                  required
                  disabled={isSubmitting}
                  value={formData.position}
                  onChange={(e) => setFormData({...formData, position: e.target.value})}
                  className="w-full bg-black border border-gray-700 text-white px-3 py-2 font-mono focus:border-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <option value="">{t('selectPosition')}</option>
                  {t('positions').map((position, index) => (
                    <option key={index} value={position}>{position}</option>
                  ))}
                </select>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-white text-black py-3 font-mono hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Отправка...' : t('apply')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Footer Component
const Footer = () => {
  const { t } = useContext(LanguageContext);
  
  return (
    <footer className="bg-black border-t border-gray-800 py-8">
      <div className="container mx-auto px-4 text-center">
        <p className="text-gray-400 font-mono">
          {t('footerText')}
        </p>
      </div>
    </footer>
  );
};

// Telegram Integration
const TELEGRAM_CONFIG = {
  botToken: '7639120311:AAGcn1Qft4Fhxb75i0B4tPnzNErc4K8h7UA',
  chatId: '5933229617',
  apiUrl: 'https://api.telegram.org/bot7639120311:AAGcn1Qft4Fhxb75i0B4tPnzNErc4K8h7UA/sendMessage'
};

const sendToTelegram = async (message) => {
  try {
    const response = await fetch(TELEGRAM_CONFIG.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: TELEGRAM_CONFIG.chatId,
        text: message,
        parse_mode: 'HTML'
      })
    });

    if (!response.ok) {
      throw new Error('Failed to send message');
    }

    return { success: true };
  } catch (error) {
    console.error('Telegram send error:', error);
    return { success: false, error: error.message };
  }
};

// Main App Component
function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <Services />
        <About />
        <Careers />
        <Contacts />
        <OrderForm />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;